import { promises, stats } from "@/mocks/home";

export default function PromiseSection() {
  return (
    <section id="promise" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-5">
            <p className="text-xs tracking-[0.25em] uppercase text-primary-600 mb-3">公开承诺</p>
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-tight">
              我们对每一条匿名爆料的处理原则
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              这些原则不随个案变化。如果你发现任何环节与承诺不符，可以通过匿名渠道反馈，我们同样会处理。
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4">
              {stats.map((item) => (
                <div key={item.label} className="bg-background-100 border border-background-200 rounded-lg p-5">
                  <p className="font-heading font-bold text-3xl text-primary-700">
                    {item.value}
                    <span className="text-base font-medium text-foreground-500 ml-1">{item.suffix}</span>
                  </p>
                  <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{item.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <ul className="divide-y divide-background-200 border-y border-background-200">
              {promises.map((item) => (
                <li key={item} className="flex items-start gap-4 py-5">
                  <span className="shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-check-double-line" aria-hidden="true"></i>
                  </span>
                  <p className="text-sm md:text-base leading-relaxed text-foreground-800 pt-1">{item}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}